import { useState } from "react";
import { hotMangaList } from "@/mocks/manga";

const categories = ["全部", "热血动作", "治愈日常", "悬疑推理", "科幻冒险", "青春恋爱"];

export default function Recommend() {
  const [active, setActive] = useState("全部");

  const filtered =
    active === "全部"
      ? hotMangaList
      : hotMangaList.filter((item) => item.category === active);

  return (
    <section id="recommend" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
              <i className="ri-fire-line"></i>
              热门推荐
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              正在追的好故事
            </h2>
            <p className="mt-3 text-foreground-700">
              按你的阅读足迹实时更新，找到下一部让你舍不得停下来的漫画。
            </p>
          </div>

          <div className="flex flex-wrap gap-2" role="tablist" aria-label="漫画分类筛选">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active === cat
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 hover:bg-secondary-100"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((manga) => (
            <article
              key={manga.id}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={manga.cover}
                  alt={`${manga.title}漫画封面`}
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-full bg-black/50 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  {manga.tag}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-400 px-2.5 py-1 text-xs font-semibold text-accent-950">
                  <i className="ri-star-fill"></i>
                  {manga.rating}
                </span>
                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent px-3 pb-3 pt-8">
                  <span className="text-xs text-background-50">{manga.progress}</span>
                  <span className="flex items-center gap-1 text-xs text-background-50">
                    <i className="ri-eye-line"></i>
                    {manga.fans}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">{manga.title}</h3>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                    {manga.category}
                  </span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {manga.description}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">已更新 {manga.chapters} 话</span>
                  <a
                    href="#recommend"
                    className="flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    继续阅读
                    <i className="ri-arrow-right-line text-xs"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}